import { Form, Formik } from "formik";
import { InputControl, SubmitButton } from "formik-chakra-ui";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useResetPasswordMutation } from "../../store/api";
import {
  Flex,
  Box,
  Stack,
  Heading,
  Text,
  useColorModeValue,
  useToast
} from '@chakra-ui/react';
import { useState } from "react";

const ResetPassword = () => {
  const { token } = useParams();
  const toast = useToast();
  const navigate = useNavigate();
  const [passwordMatch, setPasswordMatch] = useState("");


  const [resetPassword, { data, isError, isLoading, error, isSuccess }] =
    useResetPasswordMutation();
  if (isError) {
    toast({
      title: (error as any).data.message,
      status: "error",
      duration: 5000,
    });
  }
  if (isSuccess) {
    toast({
      title: "Password changed successfully",
      status: "success",
      duration: 5000,
    });
    navigate("/signin");
  }


  return (
    <Formik
      initialValues={{ newPassword: "", confirmPassword: "" }}
      validate={values => {
        let errors = {};
        if (values.newPassword.length && values.confirmPassword.length && values.newPassword !== values.confirmPassword) {
          errors = { ...errors, confirmPassword: "Password does not match. Please verify password again" };
          setPasswordMatch("Password does not match");
          return errors;
        } else {
          setPasswordMatch("");
          return errors;
        }
      }}
      onSubmit={(values) => {
        if (token) resetPassword({ ...values, newPasswordToken: token });
      }}
    >
      <Form>
        <Flex
          minH={'100vh'}
          align={'center'}
          justify={'center'}
          bg={useColorModeValue('gray.50', 'gray.800')}>
          <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
            <Stack align={'center'}>
              <Heading color="teal" fontSize={'4xl'}>Reset your password</Heading>
            </Stack>
            <Box
              rounded={'lg'}
              bg={useColorModeValue('white', 'gray.700')}
              boxShadow={'lg'}
              p={8}>
              <Stack spacing={4}>
                <InputControl
                  isRequired
                  name="newPassword"
                  label="Password"
                  color="teal"
                  inputProps={{
                    placeholder: "Enter new password...",
                    type: "password",
                  }}
                />
                <InputControl
                  isRequired
                  name="confirmPassword"
                  label="ConfirmPassword"
                  color="teal"
                  fontSize="small"
                  inputProps={{
                    placeholder: "Enter new password again...",
                    type: "password",
                  }}
                />
                <Text color="red.500" fontSize="small">{passwordMatch}</Text>
                <Stack spacing={10}>
                  <SubmitButton _hover={{
                    bg: 'blue.500',
                  }} isLoading={isLoading}>Reset Password</SubmitButton>
                  <Flex justify="flex-end">
                    <Text as={Link} to="/signin" fontSize="small" color="teal">
                      Back to Sign in
                    </Text>
                  </Flex>
                </Stack>
              </Stack>
            </Box>
          </Stack>
        </Flex>
      </Form>
    </Formik>
  );
};

export default ResetPassword;
